import type { RouteRecordRaw } from "vue-router";
import { RoutePermissionManager } from "./route-permission-manager";

export class RoutePermissionUtils {
  private static permissionManager = RoutePermissionManager.getInstance();

  static checkRouteAccess(path: string, route?: any): boolean {
    return this.permissionManager.checkRouteAccess(path, route);
  }

  static hasPermission(permissionKey: string): boolean {
    return this.permissionManager.hasRoutePermission(permissionKey);
  }

  static hasAnyPermission(permissionKeys: string[]): boolean {
    return this.permissionManager.hasAnyRoutePermission(permissionKeys);
  }

  static hasAllPermissions(permissionKeys: string[]): boolean {
    return this.permissionManager.hasAllRoutePermissions(permissionKeys);
  }

  static filterRoutesByPermission(routes: RouteRecordRaw[]): RouteRecordRaw[] {
    return this.permissionManager.filterRoutesByPermission(
      routes as any
    ) as unknown as RouteRecordRaw[];
  }

  static filterMenuByPermission(menuItems: RouteRecordRaw[]): RouteRecordRaw[] {
    return this.permissionManager.filterMenuByPermission(
      menuItems as any
    ) as unknown as RouteRecordRaw[];
  }

  static getUserPermissions(): string[] {
    return this.permissionManager.getUserRoutePermissions();
  }

  static getUserRoles(): string[] {
    return this.permissionManager.getUserRoles();
  }

  static isInitialized(): boolean {
    return this.permissionManager.isPermissionInitialized();
  }

  static resetPermissions(): void {
    this.permissionManager.resetPermissions();
  }

  static initUserPermissions(userRoles: string[]): void {
    this.permissionManager.initRoutePermissions(userRoles);
  }
}

export const routePermission = {
  canAccess: (path: string, route?: any) =>
    RoutePermissionUtils.checkRouteAccess(path, route),
  has: (permissionKey: string) =>
    RoutePermissionUtils.hasPermission(permissionKey),
  hasAny: (permissionKeys: string[]) =>
    RoutePermissionUtils.hasAnyPermission(permissionKeys),
  hasAll: (permissionKeys: string[]) =>
    RoutePermissionUtils.hasAllPermissions(permissionKeys),
  getUserPermissions: () => RoutePermissionUtils.getUserPermissions(),
  getUserRoles: () => RoutePermissionUtils.getUserRoles(),
  isInitialized: () => RoutePermissionUtils.isInitialized(),
  reset: () => RoutePermissionUtils.resetPermissions(),
  init: (userRoles: string[]) =>
    RoutePermissionUtils.initUserPermissions(userRoles),
  filterRoutesByPermission: (routes: RouteRecordRaw[]) =>
    RoutePermissionUtils.filterRoutesByPermission(routes),
  filterMenuByPermission: (menuItems: RouteRecordRaw[]) =>
    RoutePermissionUtils.filterMenuByPermission(menuItems),
};
